'use strict';

const DealCarousel = require('./DealCarousel.js');

const Carousel = {};
window.Carousel = Carousel;

Carousel.init = function(payload, done) {
  Carousel.instance = new DealCarousel(payload);
  return done();
};

module.exports = Carousel;



// WEBPACK FOOTER //
// ./modules/carousel/frontend/desktop.js